/** 
const imageData = [
    {
        id: 1,
        title: "Fantastic Mr. Fox",
        author: "Wes Anderson",
        description: "Descrizione dettagliata del Film 1.",
        imageUrl: "/filmsimages/fantastic-mr-fox.png"
    },
    {
        id: 2,
        title: "Io, Robot",
        author: "Alex Proyas",
        description: null,
        imageUrl: "/filmsimages/io-robot.png"
    },
    {
        id: 3,
        title: "The Nightmare Before Christmas",
        author: "Henry Selick",
        description: "Descrizione dettagliata del Film 1.",
        imageUrl: "/filmsimages/the-nightmare-before-christmas.png"
    },
    {
        id: 4,
        title: "Edward Mani di Forbice",
        author: "Tim Burton",
        description: "Descrizione dettagliata del Film 2.",
        imageUrl: "/filmsimages/edward-mani-di-forbice.png"
    },
    {
        id: 5,
        title: "L'isola dei Cani",
        author: "Wes Anderson",
        description: null,
        imageUrl: "/filmsimages/isola-dei-cani.png"
    },
    {
        id: 6,
        title: "Dark Shadows",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/dark-shadows.png"
    },
    {
        id: 7,
        title: "Osmosis Jones",
        author: "Bobby Farrelly, Peter Farrelly",
        description: "Descrizione dettagliata del Film 1.",
        imageUrl: "/filmsimages/osmosi-jhones.png"
    },
    {
        id: 8,
        title: "Song to Song",
        author: "Terrence Malick",
        description: null,
        imageUrl: "/filmsimages/fantastic-mr-fox.png"
    },
    {
        id: 9,
        title: "Coraline",
        author: "Henry Selick",
        description: "Descrizione dettagliata del Film 1.",
        imageUrl: "/filmsimages/coraline.png"
    },
    {
        id: 10,
        title: "Shark Tale",
        author: "Vicky Jenson, Bibo Bergeron, Rob Letterman",
        description: null,
        imageUrl: "/filmsimages/shark-tail.png"
    },
    {
        id: 11,
        title: "110 e Lode",
        author: "Alejandro Agresti",
        description: null,
        imageUrl: "/filmsimages/110-e-lode.jpg"
    },
    {
        id: 12,
        title: "1408",
        author: "Mikael Håfström",
        description: null,
        imageUrl: "/filmsimages/1408.jpg"
    },
    {
        id: 13,
        title: "21",
        author: "Robert Luketic",
        description: null,
        imageUrl: "/filmsimages/21.jpg"
    },
    {
        id: 14,
        title: "9",
        author: "Shane Acker",
        description: null,
        imageUrl: "/filmsimages/9.jpg"
    },
    {
        id: 15,
        title: "A Beautiful Mind",
        author: "Ron Howard",
        description: null,
        imageUrl: "/filmsimages/a-beautiful-mind.jpg"
    },
    {
        id: 16,
        title: "Alice nel Paese delle Meraviglie",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/alice-nel-paese-delle-meraviglie.jpg"
    },
    {
        id: 17,
        title: "Arrietty",
        author: "Hiromasa Yonebayashi",
        description: null,
        imageUrl: "/filmsimages/arrietty.JPG"
    },
    {
        id: 18,
        title: "Asteroid City",
        author: "Wes Anderson",
        description: null,
        imageUrl: "/filmsimages/asteroid-city.jpg"
    },
    {
        id: 19,
        title: "Atlantis",
        author: "Gary Trousdale, Kirk Wise",
        description: null,
        imageUrl: "/filmsimages/atlantis.jpg"
    },
    {
        id: 20,
        title: "Attacco dei Giganti",
        author: "Tetsurō Araki",
        description: null,
        imageUrl: "/filmsimages/attacco-dei-giganti.jpg"
    },
    {
        id: 21,
        title: "Basil l'Investigatopo",
        author: "Ron Clements, Burny Mattinson, David Michener, John Musker",
        description: null,
        imageUrl: "/filmsimages/basil-linvestigatopo.jpg"
    },
    {
        id: 22,
        title: "Beetlejuice",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/beetlejuice.jpg"
    },
    {
        id: 23,
        title: "Big Fish",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/big-fish.jpg"
    },
    {
        id: 24,
        title: "Big Hero Six",
        author: "Don Hall, Chris Williams",
        description: null,
        imageUrl: "/filmsimages/big-hero-six.jpg"
    },
    {
        id: 25,
        title: "Birdman",
        author: "Alejandro González Iñárritu",
        description: null,
        imageUrl: "/filmsimages/birdman.jpg"
    },
    {
        id: 26,
        title: "BoJack Horseman",
        author: "Raphael Bob-Waksberg",
        description: null,
        imageUrl: "/filmsimages/bojack-horseman.jpg"
    },
    {
        id: 27,
        title: "Breaking Bad",
        author: "Vince Gilligan",
        description: null,
        imageUrl: "/filmsimages/breaking-bad.jpg"
    },
    {
        id: 28,
        title: "Brisby e il Segreto di NIMH",
        author: "Don Bluth",
        description: null,
        imageUrl: "/filmsimages/brisby-e-il-segreto-di-nimh.jpg"
    },
    {
        id: 29,
        title: "Cloud Atlas",
        author: "Tom Tykwer, Lana Wachowski, Lilly Wachowski",
        description: null,
        imageUrl: "/filmsimages/cloud-atlas.jpg"
    },
    {
        id: 30,
        title: "Death Note",
        author: "Tetsurō Araki",
        description: null,
        imageUrl: "/filmsimages/death-note.jpg.webp"
    },
]
*/

const imageData = [

    {
        id: 116,
        title: "The Nightmare Before Christmas",
        author: "Henry Selick",
        description: "Da quando vidi questo film la prima volta capii che era il mio preferito, e lo sarebbe stato per sempre. Ne ero ossessionato, lo vedevo anche tre volte al giorno, lo misi sul telefono per guardarlo in giro (ai tempi su un Nokia non era facile farci stare un film di due ore, mi applicai) lo convertii in mp3 per ascoltarlo anche quando andavo a dormire. Adoro lo stop motion, il concetto di animazione, lo stile misterioso e grottesco, e Halloween è la mia festa preferita. Soprattutto sono innamorato della storia, semplice sotto certi aspetti ma caspita devi avere la fantasia che prende parecchio il largo per concepire una trama del genere, è bellissimo come descrivono i sentimenti di Jack, così idolatrato eppure così solo, che si domanda in fondo quale sia il suo posto... davvero un film splendido.",
        imageUrl: "/filmsimages/the-nightmare-before-christmas.png"
    },
    {
        id: 1,
        title: "1408",
        author: "Mikael Håfström",
        description: null,
        imageUrl: "/filmsimages/1408.jpg"
    },
    {
        id: 48,
        title: "Il Pianeta del Tesoro",
        author: "Ron Clements, John Musker",
        description: null,
        imageUrl: "/filmsimages/il-pianeta-del-tesoro.jpg"
    },
    {
        id: 19,
        title: "Coraline",
        author: "Henry Selick",
        description: null,
        imageUrl: "/filmsimages/coraline.png"
    },
    {
        id: 26,
        title: "Fantastic Mr. Fox",
        author: "Wes Anderson",
        description: "E' un film dolce, sincero, con dei colori e delle ambientazione che ti fa venire voglia di vivere in un mondo alternativo dove tutto ha dei toni pastello. La colonna sonora bellissima, l'ho guardato per mesi prima di andare a dormire. Il protagonista poi è un gran figo, poche volte ho pensato 'cavolo vorrei proprio essere quella volpe' ma questa è decisamente una di quelle.",
        imageUrl: "/filmsimages/fantastic-mr-fox.png"
    },
    {
        id: 102,
        title: "Shark Tail",
        author: "Bibo Bergeron, Vicky Jenson, Rob Letterman",
        description: null,
        imageUrl: "/filmsimages/shark-tail.png"
    },
    {
        id: 103,
        title: "Si Alza il Vento",
        author: "Hayao Miyazaki",
        description: "E' il mio film preferito dello studio Ghibli, diverso dagli altri più surreali, mi piace per la semplicità e per come sia un ritratto realistico di un individuo qualunque che in fondo vive la sua vita. La metafora del volo è stupenda e la colonna sonora si sposa benissimo con il tema, le esperienze oniriche sono veramente dolci. E' un film triste, con uno sfondo triste e una storia triste, ma non per questo non ci si può trovare della bellezza in tutto questo.",
        imageUrl: "/filmsimages/si-alza-il-vento.png"
    },
    {
        id: 104,
        title: "Sinbad",
        author: "Patrick Gilmore, Tim Johnson",
        description: null,
        imageUrl: "/filmsimages/sinbad.JPG"
    },
    {
        id: 37,
        title: "Il Castello Errante di Howl",
        author: "Hayao Miyazaki",
        description: null,
        imageUrl: "/filmsimages/il-castello-errante-di-howl.jpg"
    },
    {
        id: 42,
        title: "Il Gigante di Ferro",
        author: "Brad Bird",
        description: "Capolavoro d'animazione. Piango sempre in più di una scena, è veramente assurdo che una volta i film per bambini avessero un livello artistico di questo livello, il formato cinematografico, il sarcasmo, la morale, l'amore, il sacrificio...",
        imageUrl: "/filmsimages/il-gigante-di-ferro.jpg"
    },
    {
        id: 33,
        title: "Grand Budapest Hotel",
        author: "Wes Anderson",
        description: null,
        imageUrl: "/filmsimages/grand-budapest-hotel.jpg"
    },
    {
        id: 20,
        title: "Dark Shadows",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/dark-shadows.png"
    },
    {
        id: 12,
        title: "Big Fish",
        author: "Tim Burton",
        description: "Non so perché ma questo film sembra un po' la mia vita, io che racconto storie di vicende assurde che mi sono successe. Comunque film splendido, dolce, motivante, c'è tanto amore in questo film, e lo stile davvero è punta di diamante che lo rende veramente un capolavoro per me.",
        imageUrl: "/filmsimages/big-fish.jpg"
    },
    {
        id: 89,
        title: "Osmosi Jhones",
        author: "Bobby Farrelly, Peter Farrelly",
        description: "Questo film è cazzo esilarante, cioè il genio lo si vede da questi film, il villain è forse il migliore in assoluto.",
        imageUrl: "/filmsimages/osmosi-jhones.png"
    },
    {
        id: 124,
        title: "Uomini che Odiano le Donne",
        author: "David Fincher",
        description: null,
        imageUrl: "/filmsimages/uomini-che-odiano-le-donne.jpg"
    },
    {
        id: 2,
        title: "21",
        author: "Robert Luketic",
        description: null,
        imageUrl: "/filmsimages/21.jpg"
    },
    {
        id: 3,
        title: "9",
        author: "Shane Acker",
        description: null,
        imageUrl: "/filmsimages/9.jpg"
    },
    {
        id: 4,
        title: "A Beautiful Mind",
        author: "Ron Howard",
        description: null,
        imageUrl: "/filmsimages/a-beautiful-mind.jpg"
    },
    {
        id: 5,
        title: "Alice nel Paese delle Meraviglie",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/alice-nel-paese-delle-meraviglie.jpg"
    },
    {
        id: 6,
        title: "Arrietty",
        author: "Hiromasa Yonebayashi",
        description: null,
        imageUrl: "/filmsimages/arrietty.JPG"
    },
    {
        id: 7,
        title: "Asteroid City",
        author: "Wes Anderson",
        description: "Questo film l'ho visto una ventina di volte, non è piaciuto a nessuno, e anche io se lo valuto come 'film' non posso dare un opinioni positiva con i canoni standard di valutazione, ma se lo si concepisce come opera artistica è veramente un capolavoro, la scena finale con il protagonista che lascia la scena e domanda 'I still don't understand the play' è un dolce modo per chiedersi il senso della vita, e la risposta successivo credo sia un'ottima filosofia per godersela appieno: non importa, stai facendo bene, continua così', piango sempre in questa scena, e anche la successiva con l'attrice all'altra finestra è veramente recitata magistralmente. Si mi piace proprio.",
        imageUrl: "/filmsimages/asteroid-city.jpg"
    },
    {
        id: 8,
        title: "Atlantis",
        author: "Gary Trousdale, Kirk Wise",
        description: null,
        imageUrl: "/filmsimages/atlantis.jpg"
    },
    {
        id: 9,
        title: "Attacco dei Giganti",
        author: "Tetsurō Araki",
        description: null,
        imageUrl: "/filmsimages/attacco-dei-giganti.jpg"
    },
    {
        id: 10,
        title: "Basil L'investigatopo",
        author: "Ron Clements, Burny Mattinson, David Michener, John Musker",
        description: null,
        imageUrl: "/filmsimages/basil-linvestigatopo.jpg"
    },
    {
        id: 11,
        title: "Beetlejuice",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/beetlejuice.jpg"
    },
    {
        id: 13,
        title: "Big Hero Six",
        author: "Don Hall, Chris Williams",
        description: null,
        imageUrl: "/filmsimages/big-hero-six.jpg"
    },
    {
        id: 14,
        title: "Birdman",
        author: "Alejandro G. Iñárritu",
        description: null,
        imageUrl: "/filmsimages/birdman.jpg"
    },
    {
        id: 15,
        title: "Bojack Horseman",
        author: "Raphael Bob-Waksberg",
        description: null,
        imageUrl: "/filmsimages/bojack-horseman.jpg"
    },
    {
        id: 16,
        title: "Breaking Bad",
        author: "Vince Gilligan",
        description: null,
        imageUrl: "/filmsimages/breaking-bad.jpg"
    },
    {
        id: 17,
        title: "Brisby e il Segreto di NIMH",
        author: "Don Bluth",
        description: null,
        imageUrl: "/filmsimages/brisby-e-il-segreto-di-nimh.jpg"
    },
    {
        id: 18,
        title: "Cloud Atlas",
        author: "Lana Wachowski, Lilly Wachowski, Tom Tykwer",
        description: null,
        imageUrl: "/filmsimages/cloud-atlas.jpg"
    },
    {
        id: 21,
        title: "Death Note",
        author: "Tetsurō Araki",
        description: null,
        imageUrl: "/filmsimages/death-note.jpg"
    },
    {
        id: 22,
        title: "Desperate Housewives",
        author: "Marc Cherry",
        description: null,
        imageUrl: "/filmsimages/desperate-housewives.jpg"
    },
    {
        id: 23,
        title: "Edward Mani di Forbice",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/edward-mani-di-forbice.png"
    },
    {
        id: 24,
        title: "Eternal Sunshine of the Spotless Mind",
        author: "Michel Gondry",
        description: null,
        imageUrl: "/filmsimages/eternal-sunshine-of-the-spotless-mind.jpg"
    },
    {
        id: 25,
        title: "Faccia a Faccia",
        author: "Sergio Sollima",
        description: null,
        imageUrl: "/filmsimages/faccia-a-faccia.jpg"
    },
    {
        id: 27,
        title: "Fight Club",
        author: "David Fincher",
        description: null,
        imageUrl: "/filmsimages/fight-club.jpg"
    },
    {
        id: 28,
        title: "Frankenweenie",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/frankenweenie.jpg"
    },
    {
        id: 29,
        title: "Galline in Fuga",
        author: "Peter Lord, Nick Park",
        description: null,
        imageUrl: "/filmsimages/galline-in-fuga.jpg"
    },
    {
        id: 30,
        title: "Genio Ribelle",
        author: "Gus Van Sant",
        description: null,
        imageUrl: "/filmsimages/genio-ribelle.jpg"
    },
    {
        id: 31,
        title: "Gifted",
        author: "Marc Webb",
        description: null,
        imageUrl: "/filmsimages/gifted.jpg"
    },
    {
        id: 32,
        title: "Gone Girl",
        author: "David Fincher",
        description: null,
        imageUrl: "/filmsimages/gone-girl.jpg"
    },
    {
        id: 34,
        title: "Green Book",
        author: "Peter Farrelly",
        description: null,
        imageUrl: "/filmsimages/green-book.jpg"
    },
    {
        id: 35,
        title: "Hocus Pocus",
        author: "Kenny Ortega",
        description: null,
        imageUrl: "/filmsimages/hocus-pocus.jpg"
    },
    {
        id: 36,
        title: "How I Met Your Mother",
        author: "Carter Bays, Craig Thomas",
        description: null,
        imageUrl: "/filmsimages/how-i-met-your-mother.jpg"
    },
    {
        id: 38,
        title: "Il Corvo",
        author: "Alex Proyas",
        description: null,
        imageUrl: "/filmsimages/il-corvo.jpg"
    },
    {
        id: 39,
        title: "Il Destino di un Cavaliere",
        author: "Brian Helgeland",
        description: null,
        imageUrl: "/filmsimages/il-destino-di-un-cavaliere.jpg"
    },
    {
        id: 40,
        title: "Il Diavolo Veste Prada",
        author: "David Frankel",
        description: null,
        imageUrl: "/filmsimages/il-diavolo-veste-prada.jpg"
    },
    {
        id: 41,
        title: "Il Diritto di Contare",
        author: "Theodore Melfi",
        description: null,
        imageUrl: "/filmsimages/il-diritto-di-contare.jpg"
    },
    {
        id: 43,
        title: "Il Grande Gatsby",
        author: "Baz Luhrmann",
        description: null,
        imageUrl: "/filmsimages/il-grande-gatsby.jpg"
    },
    {
        id: 44,
        title: "Il Labirinto del Fauno",
        author: "Guillermo del Toro",
        description: null,
        imageUrl: "/filmsimages/il-labirinto-del-fauno.jpg"
    },
    {
        id: 45,
        title: "Il Miglio Verde",
        author: "Frank Darabont",
        description: null,
        imageUrl: "/filmsimages/il-miglio-verde.jpg"
    },
    {
        id: 46,
        title: "Il Mio Vicino Totoro",
        author: "Hayao Miyazaki",
        description: null,
        imageUrl: "/filmsimages/il-mio-vicino-totoro.jpg"
    },
    {
        id: 47,
        title: "Il Mistero dei Templari",
        author: "Jon Turteltaub",
        description: null,
        imageUrl: "/filmsimages/il-mistero-dei-templari.jpg"
    },
    {
        id: 49,
        title: "Il Ragazzo e l Airone",
        author: "Hayao Miyazaki",
        description: null,
        imageUrl: "/filmsimages/il-ragazzo-e-lairone.JPG"
    },
    {
        id: 50,
        title: "Il Regno di Ga'Hoole",
        author: "Zack Snyder",
        description: null,
        imageUrl: "/filmsimages/il-regno-di-gahoole.jpg"
    },
    {
        id: 51,
        title: "Il Trono di Spade",
        author: "David Benioff, D. B. Weiss",
        description: null,
        imageUrl: "/filmsimages/il-trono-di-spade.jpg"
    },
    {
        id: 52,
        title: "Immagina Che",
        author: "Karey Kirkpatrick",
        description: null,
        imageUrl: "/filmsimages/immagina-che.jpg"
    },
    {
        id: 53,
        title: "Insideman",
        author: "Spike Lee",
        description: null,
        imageUrl: "/filmsimages/insideman.jpg"
    },
    {
        id: 54,
        title: "Interstellar",
        author: "Christopher Nolan",
        description: null,
        imageUrl: "/filmsimages/interstellar.jpg"
    },
    {
        id: 55,
        title: "Io Robot",
        author: "Alex Proyas",
        description: null,
        imageUrl: "/filmsimages/io-robot.png"
    },
    {
        id: 56,
        title: "I Robinson",
        author: "Stephen J. Anderson",
        description: null,
        imageUrl: "/filmsimages/i-robinson.jpg"
    },
    {
        id: 57,
        title: "I Rubacchiotti",
        author: "Tom Harper",
        description: null,
        imageUrl: "/filmsimages/i-rubacchiotti.jpg"
    },
    {
        id: 58,
        title: "I Sospiri del Mio Cuore",
        author: "Yoshifumi Kondō",
        description: null,
        imageUrl: "/filmsimages/i-sospiri-del-mio-cuore.jpg"
    },
    {
        id: 59,
        title: "Isola dei Cani",
        author: "Wes Anderson",
        description: null,
        imageUrl: "/filmsimages/isola-dei-cani.png"
    },
    {
        id: 60,
        title: "James e la Pesca Gigante",
        author: "Henry Selick",
        description: null,
        imageUrl: "/filmsimages/james-e-la-pesca-gigante.jpg"
    },
    {
        id: 61,
        title: "Kangaroo Jack",
        author: "David McNally",
        description: null,
        imageUrl: "/filmsimages/kangaroo-jack.jpg"
    },
    {
        id: 62,
        title: "Kate e Leopold",
        author: "James Mangold",
        description: null,
        imageUrl: "/filmsimages/kate-e-leopold.jpg"
    },
    {
        id: 63,
        title: "Kiki Consegne a Domicilio",
        author: "Hayao Miyazaki",
        description: null,
        imageUrl: "/filmsimages/kiki-consegne-a-domicilio.jpg"
    },
    {
        id: 64,
        title: "La Bella e la Bestia",
        author: "Gary Trousdale, Kirk Wise",
        description: null,
        imageUrl: "/filmsimages/la-bella-e-la-bestia.jpg"
    },
    {
        id: 65,
        title: "La Città Incantata",
        author: "Hayao Miyazaki",
        description: null,
        imageUrl: "/filmsimages/la-città-incantata.jpg"
    },
    {
        id: 66,
        title: "La Collina dei Papaveri",
        author: "Gorō Miyazaki",
        description: null,
        imageUrl: "/filmsimages/la-collina-dei-papaveri.jpg"
    },
    {
        id: 67,
        title: "La Forma dell Acqua",
        author: "Guillermo del Toro",
        description: null,
        imageUrl: "/filmsimages/la-forma-dellacqua.jpg"
    },
    {
        id: 68,
        title: "La Gabbianella e il Gatto",
        author: "Enzo D'Alò",
        description: null,
        imageUrl: "/filmsimages/la-gabbianella-e-il-gatto.jpg"
    },
    {
        id: 69,
        title: "La Grande Bellezza",
        author: "Paolo Sorrentino",
        description: null,
        imageUrl: "/filmsimages/la-grande-bellezza.jpg"
    },
    {
        id: 70,
        title: "La Leggenda degli Uomini Straordinari",
        author: "Stephen Norrington",
        description: null,
        imageUrl: "/filmsimages/la-leggenda-degli-uomini-straordinari.jpg"
    },
    {
        id: 71,
        title: "La Mummia",
        author: "Stephen Sommers",
        description: null,
        imageUrl: "/filmsimages/la-mummia.jpg"
    },
    {
        id: 72,
        title: "La Regina degli Scacchi",
        author: "Scott Frank",
        description: null,
        imageUrl: "/filmsimages/la-regina-degli-scacchi.jpg"
    },
    {
        id: 73,
        title: "La Spada Magica",
        author: "Frederik Du Chau",
        description: null,
        imageUrl: "/filmsimages/la-spada-magica.jpg"
    },
    {
        id: 74,
        title: "La Sposa Cadavere",
        author: "Tim Burton, Mike Johnson",
        description: null,
        imageUrl: "/filmsimages/la-sposa-cadavere.jpg"
    },
    {
        id: 75,
        title: "La Teoria del Tutto",
        author: "James Marsh",
        description: null,
        imageUrl: "/filmsimages/la-teoria-del-tutto.jpg"
    },
    {
        id: 76,
        title: "Ladyhawke",
        author: "Richard Donner",
        description: null,
        imageUrl: "/filmsimages/ladyhawke.jpg"
    },
    {
        id: 77,
        title: "L'Arte di Vincere",
        author: "Bennett Miller",
        description: null,
        imageUrl: "/filmsimages/larte-di-vincere.jpg"
    },
    {
        id: 78,
        title: "Le 5 Leggende",
        author: "Peter Ramsey",
        description: null,
        imageUrl: "/filmsimages/le-5-leggende.jpg"
    },
    {
        id: 79,
        title: "Le Follie dell'Imperatore",
        author: "Mark Dindal",
        description: null,
        imageUrl: "/filmsimages/le-follie-dellimperatore.jpg"
    },
    {
        id: 80,
        title: "L'Uomo Senza Volto",
        author: "Mel Gibson",
        description: null,
        imageUrl: "/filmsimages/luomo-senza-volto.jpg"
    },
    {
        id: 81,
        title: "Man in Black",
        author: "Barry Sonnenfeld",
        description: null,
        imageUrl: "/filmsimages/man-in-black.jpg"
    },
    {
        id: 82,
        title: "Matrix",
        author: "Lana Wachowski, Lilly Wachowski",
        description: null,
        imageUrl: "/filmsimages/matrix.jpg"
    },
    {
        id: 83,
        title: "Megamind",
        author: "Tom McGrath",
        description: null,
        imageUrl: "/filmsimages/megamind.jpg"
    },
    {
        id: 84,
        title: "Neverwas",
        author: "Joshua Michael Stern",
        description: null,
        imageUrl: "/filmsimages/neverwas.jpg"
    },
    {
        id: 85,
        title: "Non è un Paese per Vecchi",
        author: "Joel Coen, Ethan Coen",
        description: null,
        imageUrl: "/filmsimages/non-è-un-paese-per-vecchi.jpg"
    },
    {
        id: 86,
        title: "Oceans Eleven",
        author: "Steven Soderbergh",
        description: null,
        imageUrl: "/filmsimages/oceans-eleven.jpg"
    },
    {
        id: 87,
        title: "Onward",
        author: "Dan Scanlon",
        description: null,
        imageUrl: "/filmsimages/onward.jpg"
    },
    {
        id: 88,
        title: "Oppenheimer",
        author: "Christopher Nolan",
        description: null,
        imageUrl: "/filmsimages/oppenheimer.jpg"
    },
    {
        id: 90,
        title: "Piovono Polpette",
        author: "Phil Lord, Christopher Miller",
        description: null,
        imageUrl: "/filmsimages/piovono-polpette.jpg"
    },
    {
        id: 91,
        title: "Porco Rosso",
        author: "Hayao Miyazaki",
        description: null,
        imageUrl: "/filmsimages/porco-rosso.jpg"
    },
    {
        id: 92,
        title: "Ralph Spaccatutto",
        author: "Rich Moore",
        description: null,
        imageUrl: "/filmsimages/ralph-spaccatutto.jpg"
    },
    {
        id: 93,
        title: "Ratatouille",
        author: "Brad Bird, Jan Pinkava",
        description: null,
        imageUrl: "/filmsimages/ratatouille.jpg"
    },
    {
        id: 94,
        title: "Ready Player One",
        author: "Steven Spielberg",
        description: null,
        imageUrl: "/filmsimages/ready-player-one.jpg"
    },
    {
        id: 95,
        title: "Remember the Titans",
        author: "Boaz Yakin",
        description: null,
        imageUrl: "/filmsimages/remember-the-titans.jpg"
    },
    {
        id: 96,
        title: "Rick & Morty",
        author: "Dan Harmon, Justin Roiland",
        description: null,
        imageUrl: "/filmsimages/rick-&-morty.jpg"
    },
    {
        id: 97,
        title: "Salto nel Buio",
        author: "Joe Dante",
        description: null,
        imageUrl: "/filmsimages/salto-nel-buio.jpg"
    },
    {
        id: 98,
        title: "Sapori e Dissapori",
        author: "Scott Hicks",
        description: null,
        imageUrl: "/filmsimages/sapori-e-dissapori.jpg"
    },
    {
        id: 99,
        title: "Scrubs",
        author: "Bill Lawrence",
        description: null,
        imageUrl: "/filmsimages/scrubs.jpg"
    },
    {
        id: 100,
        title: "Seven",
        author: "David Fincher",
        description: null,
        imageUrl: "/filmsimages/seven.jpg"
    },
    {
        id: 101,
        title: "Shooter",
        author: "Antoine Fuqua",
        description: null,
        imageUrl: "/filmsimages/shooter.jpg"
    },
    {
        id: 105,
        title: "Sleepy Hollow",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/sleepy-hollow.jpg"
    },
    {
        id: 106,
        title: "Soul",
        author: "Pete Docter, Kemp Powers",
        description: null,
        imageUrl: "/filmsimages/soul.jpg"
    },
    {
        id: 107,
        title: "Spider Man",
        author: "Joaquim Dos Santos",
        description: null,
        imageUrl: "/filmsimages/spider-man.jpg"
    },
    {
        id: 108,
        title: "Stargate",
        author: "Roland Emmerich",
        description: null,
        imageUrl: "/filmsimages/stargate.jpg"
    },
    {
        id: 109,
        title: "Sweeney Todd",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/sweeney-todd.jpg"
    },
    {
        id: 110,
        title: "Taron e la Pentola Magica",
        author: "Ted Berman, Richard Rich",
        description: null,
        imageUrl: "/filmsimages/taron-e-la-pentola-magica.jpg"
    },
    {
        id: 111,
        title: "The Aviator",
        author: "Martin Scorsese",
        description: null,
        imageUrl: "/filmsimages/the-aviator.jpg"
    },
    {
        id: 112,
        title: "The Crown",
        author: "Peter Morgan",
        description: null,
        imageUrl: "/filmsimages/the-crown.jpg"
    },
    {
        id: 113,
        title: "The Departed",
        author: "Martin Scorsese",
        description: null,
        imageUrl: "/filmsimages/the-departed.jpg"
    },
    {
        id: 114,
        title: "The French Dispatch",
        author: "Wes Anderson",
        description: null,
        imageUrl: "/filmsimages/the-french-dispatch.jpg"
    },
    {
        id: 115,
        title: "The Help",
        author: "Tate Taylor",
        description: null,
        imageUrl: "/filmsimages/the-help.jpg"
    },
    {
        id: 117,
        title: "The Social Network",
        author: "David Fincher",
        description: null,
        imageUrl: "/filmsimages/the-social-network.jpg"
    },
    {
        id: 118,
        title: "The Truman Show",
        author: "Peter Weir",
        description: null,
        imageUrl: "/filmsimages/the-truman-show.jpg"
    },
    {
        id: 119,
        title: "The Umbrella Academy",
        author: "Steve Blackman",
        description: null,
        imageUrl: "/filmsimages/the-umbrella-academy.jpg"
    },
    {
        id: 120,
        title: "The Wolf of Wall Street",
        author: "Martin Scorsese",
        description: null,
        imageUrl: "/filmsimages/the-wolf-of-wall-street.jpg"
    },
    {
        id: 121,
        title: "Un Amore all'Improvviso",
        author: "Robert Schwentke",
        description: null,
        imageUrl: "/filmsimages/un-amore-allimprovviso.jpg"
    },
    {
        id: 122,
        title: "Un Topolino Sotto Sfratto",
        author: "Gore Verbinski",
        description: null,
        imageUrl: "/filmsimages/un-topolino-sotto-sfratto.jpg"
    },
    {
        id: 123,
        title: "Una Serie di Sfortunati Eventi",
        author: "Brad Silberling",
        description: null,
        imageUrl: "/filmsimages/una-serie-di-sfortunati-eventi.jpg"
    },
    {
        id: 125,
        title: "V per Vendetta",
        author: "James McTeigue",
        description: null,
        imageUrl: "/filmsimages/v-per-vendetta.jpg"
    },
    {
        id: 126,
        title: "Vincent",
        author: "Tim Burton",
        description: null,
        imageUrl: "/filmsimages/vincent.jpg"
    },
    {
        id: 127,
        title: "Watchmen",
        author: "Zack Snyder",
        description: null,
        imageUrl: "/filmsimages/watchmen.jpg"
    },
    {
        id: 128,
        title: "Zodiac",
        author: "David Fincher",
        description: null,
        imageUrl: "/filmsimages/zodiac.jpg"
    },
    {
        id: 129,
        title: "Zona d'Ombra",
        author: "Peter Landesman",
        description: null,
        imageUrl: "/filmsimages/zona-dombra.jpg"
    },
    {
        id: 130,
        title: "Space Jam",
        author: "Joe Pytka",
        description: null,
        imageUrl: "/filmsimages/space-jam.jpg"
    }
];
export default imageData;


//-------------